import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CommandCenter from './components/CommandCenter';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CommandCenter />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;